import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import OrientedSpeechBalloon from '../../../domain/entities/OrientedSpeechBalloon';

export default function reducer(
  state: {[key: number]: OrientedSpeechBalloon} = {},
  action: AnyAction,
): {[key: number]: OrientedSpeechBalloon} {
  switch (action.type) {
    case Types.IndexOrientedSpeechBalloonsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (
            obj: {[key: number]: OrientedSpeechBalloon},
            record: OrientedSpeechBalloon,
          ) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowOrientedSpeechBalloonSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
}
